module.exports = __webpack_public_path__ + "static/media/image-card-4.6ab09657.png";